import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

interface LogoSliderProps {
  logos: { id: number; src: string; alt: string }[];
}

const ClientSlider: React.FC<LogoSliderProps> = ({ logos }) => {
  return (
    <div className="w-full py-12 bg-gray-100 my-20 text-center">
      <div className="max-w-3xl mx-auto mb-8">
        <h2 className="text-xl md:text-2xl font-semibold text-gray-800">
          Our Valued Clients
        </h2>
        <p className="text-gray-600 mt-2">
          Showcasing a few of the esteemed brands and organizations we proudly
          serve. Their trust fuels our dedication to excellence.
        </p>
      </div>

      <Swiper
        slidesPerView={3}
        breakpoints={{
          640: { slidesPerView: 8 },
        }}
        spaceBetween={5}
        loop={true}
        autoplay={{ disableOnInteraction: false }}
        modules={[Autoplay]}
        className="w-full max-w-5xl mx-auto"
      >
        {logos.map((logo) => (
          <SwiperSlide key={logo.id} className="flex justify-center">
            <img
              src={logo.src}
              alt={logo.alt}
              className="h-16 w-full object-contain"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ClientSlider;
